import { useLocation } from 'react-router-dom';
import useUser from '../../auth/useUser';

/* ── Page metadata keyed by pathname ── */
const PAGE_META = {
  '/':              { title: 'Dashboard',            crumb: 'FocusOne · Overview' },
  '/catalogue':     { title: 'Product Catalogue',    crumb: 'FocusOne · Supplier Data' },
  '/suppliers':     { title: 'Suppliers',            crumb: 'FocusOne · Supplier Data' },
  '/history':       { title: 'List History',         crumb: 'FocusOne · Supplier Data' },
  '/signals':       { title: 'Market Signals',       crumb: 'FocusOne · Intelligence' },
  '/opportunities': { title: 'NL Opportunities',     crumb: 'FocusOne · Intelligence' },
  '/bc':            { title: 'Business Case',        crumb: 'FocusOne · Qualification' },
  '/bc/editor':     { title: 'BC Editor — Valsartan 160 mg', crumb: 'FocusOne · Qualification' },
  '/pipeline':      { title: 'Project Pipeline',     crumb: 'FocusOne · Qualification' },
  '/upload':        { title: 'Upload Supplier List', crumb: 'FocusOne · Supplier Data' },
  '/settings':      { title: 'Settings',             crumb: 'FocusOne · Preferences' },
  '/profile':       { title: 'My Profile',           crumb: null },
};

export default function Topbar({ onToggleSidebar, notifCount, onToggleNotif }) {
  const location = useLocation();
  const { displayName } = useUser();
  const raw = PAGE_META[location.pathname] || { title: 'FocusOne', crumb: 'FocusOne' };
  const meta = { ...raw, crumb: raw.crumb ?? `FocusOne · ${displayName}` };

  return (
    <>
      {/* Mobile hamburger */}
      <button
        className="tb-btn d-lg-none"
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Page title & breadcrumb */}
      <div className="d-none d-sm-block">
        <div className="tb-title">{meta.title}</div>
        <div className="tb-crumb">{meta.crumb}</div>
      </div>

      <div className="flex-grow-1" />

      {/* ── Notification bell ── */}
      <button
        className="tb-btn position-relative"
        onClick={onToggleNotif}
        aria-label="Notifications"
      >
        <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
        {notifCount > 0 && <span className="nb">{notifCount}</span>}
      </button>
    </>
  );
}
